export default __webpack_public_path__ + "static/media/guest_08_2_cynthia_zanoni.d0ba1c1e.png";